import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EHttpCode, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import {
  getDefaultPagination,
  handleSuccess,
  handleApiErrorWithFallback,
  handleError,
} from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const LanguageApi = {
  getLanguageAssociation: (
    action: { page: number; limit: number; productId?: string },
    dispatch: Dispatch
  ) => {
    const queryParams =
      `${EUrlParams.Page}=` + action.page + `&${EUrlParams.Limit}=` + action.limit;
    return AxiosClient.post(`/product/v1/language/association/read?${queryParams}`, {
      productCode: action.productId ? action.productId : '',
    })
      .then((response) => {
        return handlePaginatedData(response, { ...action, searchCode: action.productId });
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.productId },
          EAction.Read,
          EApiType.LanguageAssociationKey,
          [EHttpCode.Status404]
        );
      });
  },

  getLanguages: (
    action: { page: number; limit: number; searchCode?: string },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    return AxiosClient.post(`/language/v1/read?${queryParams}`, [])
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.LanguageKey
        );
      });
  },

  getLanguageDetails: (action: { request: string[] }, dispatch: Dispatch) => {
    const queryParams = action.request.length === 0 ? getDefaultPagination() : '';
    return AxiosClient.post('/language/v1/read?' + queryParams, action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },

  updateLanguageAssociation: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/product/v1/language/association/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  deleteLanguage: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/language/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  updateLanguage: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/language/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  createLanguage: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/language/v1/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  deleteLanguageAssociation: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/product/v1/language/association/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },
};
